import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Assessment from "../../components/assessment/Assessment";
import QuestionPaper from "../../components/assessment/QuestionPaper";
import Layout from "../../components/layout/DefaultLayout";
import api from "../../utils/api";

const AssessmentPage = ({ onExit, isQuestionPaperView = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const assessment = location.state;

  const [questionsData, setQuestionsData] = useState([]);
  const [loading, setLoading] = useState(true);


  const fetchQuestionsFromAssessment = async (assessment) => {
    try {
      const response = await api.post("/questions/assessment", assessment);
      return response.data; // raw list of Question entities
    } catch (error) {
      console.error("Failed to fetch questions:", error);
      return [];
    }
  };


  useEffect(() => {
    if (!assessment) {
      navigate("/");
      return;
    }

    const loadQuestions = async () => {
      setLoading(true);
      try {
        const rawQuestions = await fetchQuestionsFromAssessment(assessment);
        setQuestionsData(rawQuestions);
      } catch (err) {
        alert("Failed to load questions.");
      } finally {
        setLoading(false);
      }
    };

    loadQuestions();
  }, [assessment, navigate]);



  if (loading) {
    return (
      <Layout>
        <p style={{ padding: "2rem" }}>Loading assessment...</p>
      </Layout>
    );
  }

  return (
    <>
      {
        isQuestionPaperView ? (
          <QuestionPaper questionsData={questionsData} />
        ) : (
          <Layout>
            <Assessment
              questionsData={questionsData}
              timerDuration={assessment.timerDuration}
              onExit={onExit}
            />
          </Layout >
        )}
    </>
  );
};

export default AssessmentPage;
